import { render, staticRenderFns } from "./PuzzlePreview.vue?vue&type=template&id=3e5af964&scoped=true"
import script from "./PuzzlePreview.vue?vue&type=script&lang=js"
export * from "./PuzzlePreview.vue?vue&type=script&lang=js"
import style0 from "./PuzzlePreview.vue?vue&type=style&index=0&id=3e5af964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5af964",
  null
  
)

export default component.exports